import { format, getYear } from 'date-fns'

import Vue from 'vue'
import Router from 'vue-router'

import VueScrollTo from 'vue-scrollto'
import miniToastr from 'mini-toastr'
import VueCollapse from 'vue2-collapse'
import VTooltip from 'v-tooltip'
import axios from 'axios'
import globalMixin from '../mixins/global.js'

import PersonalApp from '../PersonalApp.vue'
import router from '../router/personal.js'
import store from '../store/index.js'


Vue.config.productionTip = false

Vue.use(VueScrollTo)
Vue.use(VTooltip)

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({ types: toastTypes })

Vue.use(Router)
Vue.use(VueCollapse)

Vue.filter('formatDate', (value, formatStr) => {
  if (value) {
    if (!formatStr) {
      // eslint-disable-next-line
      formatStr = 'MM/dd/yyyy HH:MM';
    }
    if (formatStr === 'at') {
      return `${format(new Date(value), 'MM/dd/yyyy')} at ${format(new Date(value), 'HH:mm')}`
    }
    return format(new Date(value), formatStr)
  }
  return value
})

Vue.filter('readMore', (text, length, suffix) => text.substring(0, length) + suffix)

Vue.filter('formatPrice', (value) => {
  const formattedValue = value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  return `${formattedValue} RON`
})

Vue.mixin(globalMixin.notificationMixin())

const token = localStorage.getItem('token')
if (token) {
  // eslint-disable-next-line
  axios.defaults.headers.common['Authorization'] = token;

  const yearLocal = 1985
  let year = parseInt(yearLocal) || parseInt(getYear(new Date()));

  Vue.mixin({
    data() {
      return {
        get globalYears() {
          let arr = [];
          for (let i = year; i <= parseInt(getYear(new Date())); i++ ) {
            arr.push (i);
          }
          return arr;
        },
        get recurrencyTypes() {
          let arr = [
            {
              key: 'monthly',
              name: 'Monthly',
            },
            {
              key: '2month',
              name: '2 Month',
            },
            {
              key: '3month',
              name: '3 Month',
            },
            {
              key: '4month',
              name: '4 Month',
            },
            {
              key: '5month',
              name: '5 Month',
            },
            {
              key: '6month',
              name: '6 Month',
            },
            {
              key: 'annually',
              name: 'Annually',
            }

          ];


          return arr;
        }

      }
    }
  })
}

Vue.filter('getRecurrentName', (value, recTypes) => {
  const findItem = recTypes.find((item) => item.key === value);
  if (findItem) {
    return findItem.name;
  }
  return value;
})

/* eslint-disable no-new */
new Vue({
  el: '#personal-app',
  router,
  store,
  render: h => h(PersonalApp)
})
